import { create } from "zustand";
import { persist } from "zustand/middleware";

interface FavoritesState {
  favorites: string[];
  isFavorite: (vehicleId: string) => boolean;
  toggleFavorite: (vehicleId: string) => void;
  addFavorite: (vehicleId: string) => void;
  removeFavorite: (vehicleId: string) => void;
  clearFavorites: () => void;
}

export const useFavoritesStore = create<FavoritesState>()(
  persist(
    (set, get) => ({
      favorites: [],

      isFavorite: (vehicleId: string) => {
        return get().favorites.includes(vehicleId);
      },

      toggleFavorite: (vehicleId: string) => {
        const { favorites } = get();
        if (favorites.includes(vehicleId)) {
          set({ favorites: favorites.filter((id) => id !== vehicleId) });
        } else {
          set({ favorites: [...favorites, vehicleId] });
        }
      },

      addFavorite: (vehicleId: string) => {
        const { favorites } = get();
        if (!favorites.includes(vehicleId)) {
          set({ favorites: [...favorites, vehicleId] });
        }
      },

      removeFavorite: (vehicleId: string) => {
        set({ favorites: get().favorites.filter((id) => id !== vehicleId) });
      },

      clearFavorites: () => {
        set({ favorites: [] });
      },
    }),
    {
      name: "bespokian-favorites",
    },
  ),
);
